import { InferType } from 'yup'

import { validationSchema } from './validationSchema'

export type AccountFormValues = InferType<typeof validationSchema>

export enum AccountActionType {
  Donate = 'donate',
  Plant = 'plant'
}

export enum PrimaryGoalType {
  // Business options
  MitigateEmissions = 'mitigate-emissions',
  ShowcaseImpact = 'showcase-impact',
  EngageStaff = 'engage-staff',
  HelpEnvironment = 'help-environment',
  // Personal (non-business) options
  SendECard = 'send-gift',
  FundInMemory = 'in-memory',
  MitigateCarbon = 'mitigate-emissions-non-business',
  DoRightForEnvironment = 'help-environment-non-business',
  Other = 'other'
}

export enum ProfileVisibility {
  Private = 'Private',
  Public = 'Public'
}
